import {UserContextProvider} from '@/components/Providers/UserContext';
import {GoogleOAuthProvider} from '@react-oauth/google';
import type {ReactElement} from 'react';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import StudentDirectory from './pages/StudentDirectory';

const App = (): ReactElement => {
    return (
        <BrowserRouter>
            <GoogleOAuthProvider clientId={import.meta.env.VITE_OAUTH_CLIENT_ID}>
                <UserContextProvider>
                    <Routes>
                        <Route path='/' element={<StudentDirectory />} />
                    </Routes>
                </UserContextProvider>
            </GoogleOAuthProvider>
        </BrowserRouter>
    );
};

export default App;
